import { createSelector } from 'reselect'
import { GenericWorkout } from './../../types/generic-workout'
import { WorkoutByIdResponse } from '../actions'
import { RootState } from '../reducers/rootReducers'

export const getTrainerName = (firstName: string, lastName: string): string =>
  `${firstName || ''} ${lastName || ''}`

const transformToGeneric = (w: WorkoutByIdResponse): GenericWorkout => ({
  id: w.id,
  title: w.title,
  description: w.description,
  trainerName: w.trainer
    ? getTrainerName(w.trainer.firstName, w.trainer.lastName)
    : '',
  length: w.length,
  thumbnail: w.thumbnail,
  type: w.type,
  videoUrl: w.video ? w.video[0]?.videoURL : undefined,
  headerOne: w.headerOne || undefined,
  headerTwo: w.headerTwo || undefined,
  descriptionTwo: w.descriptionTwo || undefined,
  spotifyLink: w.spotifyLink,
  published: w.published,
  intensity: w.intensity,
})

const workoutState = (state: RootState) =>
  state.entities.workoutByIdReducer.workout

export const workoutSelector = createSelector(
  workoutState,
  (workout: WorkoutByIdResponse | undefined): GenericWorkout | undefined => {
    if (workout) {
      return transformToGeneric(workout)
    }
    return undefined
  },
)
